import React, { useEffect, useState, useMemo } from "react";
import { Link, Selection, SelectionMode, Stack, Text } from "@fluentui/react";
import { useField } from "formik";
import DetailsTable from "./DetailsTable";

const OptionsTable = ({
  columns,
  data,
  fieldName,
  objectKey,
  loading,
  setOptionTable,
  title,
  multiSelect,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(fieldName);

  const selectionHook = () => {
    if (
      selection.getSelection() &&
      selection.getSelection()[0] &&
      selection.getSelection()[0][objectKey]
    ) {
      const currentSelection = selection.getSelection();
      const selectedValues = multiSelect
        ? currentSelection.map((item) => item[objectKey])
        : currentSelection[0][objectKey];

      helpers.setValue(selectedValues);
    }
  };

  const [selection, setSelection] = useState(
    new Selection({
      onSelectionChanged: () => {
        selectionHook();
      },
      selectionPreservedOnEmptyClick: true,
      selectionMode: multiSelect
        ? SelectionMode.multiple
        : SelectionMode.single,
    })
  );

  const items = useMemo(() => {
    return data
      ? data.map((item) => ({
          key: item[objectKey],
          ...item,
        }))
      : [];
  }, [data, objectKey]);

  useEffect(() => {
    setSelection((prev) => {
      const newSelection = prev;
      newSelection.setItems(items);
      if (Array.isArray(field.value)) {
        field.value.map((value) =>
          newSelection.setKeySelected(value, true, true)
        );
      } else {
        newSelection.setKeySelected(field.value, true, true);
      }
      return newSelection;
    });
  }, [items]);

  return (
    <div>
      <Stack>
        <Text block as="h1" variant="xLarge" nowrap>
          {title}
        </Text>
        <Link
          styles={{ root: { fontSize: 13, paddingLeft: 1 } }}
          onClick={() => setOptionTable("")}
        >
          {"< Close Table"}
        </Link>
      </Stack>
      {!items || items.length === 0 ? (
        <Text>There is no options to display</Text>
      ) : (
        <DetailsTable
          items={items}
          columns={columns}
          selection={selection}
          hideSelectionDetails
          loading={loading}
          mainColumn={"name"}
          detailsListProps={{ getKey: (item) => item[objectKey] }}
          selectedKey={field.value}
          shouldUsePagination
        />
      )}
    </div>
  );
};

export default OptionsTable;
